<template>
  <section class="product-slide">
    <div class="image" :style="'padding-bottom:'+size+'%; background-image: url(' + image+ ');'"></div>
  </section>
</template>

<script>
  export default {
    props: {
      image: String,
      size:  { default: 65 },
    },
  }
</script>

<style lang="scss">

  .product-slide {
    width: 100%;
    .image {
      background-size: cover;
      @media(max-width: 900px) {
        min-height: auto;
      }
      @media(max-width: 600px) {
      //  height: 300px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/shared/sliders/ImageSlide.vue